import {COURSE_LANDING_WAIT_FOR_USER} from '../actions/actionsTypes';

const courseLandingWaitUser = (state=false, action) => {
  if(action.type === COURSE_LANDING_WAIT_FOR_USER){
    return action.value
  }
  return state
}

export default courseLandingWaitUser